import { render, staticRenderFns } from "./ProcessingLoader.vue?vue&type=template&id=2f6f8308&scoped=true&"
import script from "./ProcessingLoader.vue?vue&type=script&lang=js&"
export * from "./ProcessingLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f8308",
  null
  
)

export default component.exports